import * as Yup from "yup";

import getTranslationInitialValues from "@/data/LanguageManagement/Translations/initial-values";

const getTranslationSchema = (isEdit = false) =>
  Yup.object().shape({
    key: Yup.string()
      .label("key")
      .required()
      .max(255),

    ...Object.keys(getTranslationInitialValues()).reduce((acc, key) => {
      acc[key] = Yup.string()
        .label(key)
        .optional()
        .max(255);
      return acc;
    }, {}),
  });

export default getTranslationSchema;
